"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Settings = void 0;
class Settings {
    constructor() {
        this.targetError = Settings.DEFAULT_TARGET_ERROR;
        this.targetFps = Settings.DEFAULT_TARGET_FPS;
        this.maxPending = Settings.DEFAULT_MAX_PENDING;
        this.maxBlocked = Settings.DEFAULT_MAX_BLOCKED;
        this.maxCacheSize = Settings.DEFAULT_MAX_CACHE_SIZE;
        this.drawBudget = Settings.DEFAULT_DRAW_BUDGET;
    }
}
exports.Settings = Settings;
Settings.DEFAULT_TARGET_ERROR = 3;
Settings.DEFAULT_TARGET_FPS = 20;
Settings.DEFAULT_MAX_PENDING = 6;
Settings.DEFAULT_MAX_BLOCKED = 3;
Settings.DEFAULT_MAX_CACHE_SIZE = 50 * (1 << 20); // N * 1MB (2 ^ 20)
Settings.DEFAULT_DRAW_BUDGET = 16 * (1 << 20); // N * 1MB (2 ^ 20)
